/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Confirm_Delete_Selected_TitleInputs */



/**
* | output |
* | --- |
* | "Delete Selected Items" |
*
* @param {Spaces_Confirm_Delete_Selected_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_confirm_delete_selected_title = /** @type {((inputs?: Spaces_Confirm_Delete_Selected_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Confirm_Delete_Selected_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Elemente löschen")
	return /** @type {LocalizedString} */ ("Delete Selected Items")
});